import styled from 'styled-components';

import { PrimaryDark } from '../../../../../../../styling/theme';

export const FieldSet = styled.fieldset`
  display: grid;
  justify-items: ${(props) => (props.fullWidth ? 'flex-start' : null)};
  width: ${(props) => props.fullWidth || null};
  margin-left: ${(props) => props.marginLeft || null};
  input {
    width: ${(props) => (props.fullWidth ? null : '20rem')};
    float: left;
  }
  &:focus-within {
    label {
      color: ${PrimaryDark};
    }
  }
`;

export const DateStyle = styled.div`
  width: ${(props) => props.width || '220px'};

  height: 48px;

  background: #ffffff;

  border-radius: 4px;

  .redBorder {
    font-family: Arial;
    font-style: italic;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);

    color: rgba(0, 0, 0, 0.8);
    border: none;
    border-radius: 4px;
    width: 100%;
    height: 48px;
    padding: 0.75rem;
    user-select: none;
    &:focus {
      outline-style: none;
    }
  }

  .react-datepicker-wrapper {
    width: inherit;
    .react-datepicker__input-container {
      vertical-align: middle;
    }
  }
`;
